export function calcMinCalories(profile, maintenance) {
  if (!profile || !maintenance) return null;

  const MAX_DEFICIT_RATIO = 0.35; // allow max 35% deficit

  let minCalories = maintenance * (1 - MAX_DEFICIT_RATIO);

  // absolute safety floor
//   if (profile.gender === "female") {
//     minCalories = Math.max(minCalories, 1200);
//   } else {
//     minCalories = Math.max(minCalories, 1400);
//   }

  return Math.round(minCalories);
}